import { render, staticRenderFns } from "./tags.vue?vue&type=template&id=61ae3e9a&scoped=true"
import script from "./tags.vue?vue&type=script&lang=js"
export * from "./tags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ae3e9a",
  null
  
)

export default component.exports